class HHMobileMenu extends HTMLElement {
  constructor() {
    super()

    this.submenus = this.querySelectorAll('details')
    this.submenus.forEach((submenu) => {
      submenu.addEventListener('toggle', this.onToggle.bind(this))
    })
  }

  connectedCallback() {
    this.setWindowHeightVariable()
    window.addEventListener('resize', this.setWindowHeightVariable.bind(this))
    window.addEventListener('modalClosed', this.onMobileMenuClose.bind(this))
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.setWindowHeightVariable)
    window.removeEventListener('modalClosed', this.onMobileMenuClose)
  }

  setWindowHeightVariable() {
    HH.setCSSVariable('--hh-window-height', `${window.innerHeight}px`)
  }

  onToggle(e) {
    if (e.target.hasAttribute('open')) {
      this.setAttribute('submenu-open', true)
    } else {
      this.removeAttribute('submenu-open')
    }
  }

  onMobileMenuClose(e) {
    const { target } = e
    if (!target.classList.contains('js-mobile-menu')) return
    this.submenus.forEach((submenu) => submenu.removeAttribute('open'))
  }
}

customElements.define('hh-mobile-menu', HHMobileMenu)
